import "./popover.css";

import { useState } from "react";

import { Modal } from "../modal/Modal";
import { PopoverButton } from "./popoverButton/PopoverButton";

type PopoverProps = {
  popoverHeader?: string | React.ReactNode | null;
  popoverMessage?: string | React.ReactNode | null;
  triggerAriaLabel?: string;
};

export const Popover = ({
  popoverHeader,
  popoverMessage,
  triggerAriaLabel,
}: PopoverProps) => {
  const [isOpen, setIsOpen] = useState(false);

  if (!popoverMessage) {
    return null;
  }

  return (
    <div slot="trigger-element" className="pop-over-margin">
      <PopoverButton
        triggerAriaLabel={triggerAriaLabel}
        onClick={() => setIsOpen(true)}
      />
      <Modal
        open={isOpen}
        close={() => setIsOpen(false)}
        label={popoverHeader}
        content={popoverMessage}
      ></Modal>
    </div>
  );
};
